import React from "react";
import {
  overviewItem,
  itemLabel,
  itemValue,
  policyDetails,
} from "../Shared/Styles";

export default function PolicyDetails(props) {
  if (props.policyDetails !== undefined) {
    return (
      <div style={policyDetails}>
        <div style={overviewItem}>
          <span style={itemLabel}>Policy Number</span>
          <span style={itemValue}>{props.policyDetails[0].policyNumber}</span>
        </div>

        <div style={overviewItem}>
          <span style={itemLabel}>Status</span>
          <span style={itemValue}>{props.policyDetails[0].status}</span>
        </div>

        <div>
          {/* When there are more than 2 Life Insured use this  */}
          {props.policyDetails.map((link) => (
            <>
              <div style={overviewItem}>
                <div style={itemLabel}>Life Insured</div>
                <div style={itemValue}>{link.lifeInsuredName}</div>
              </div>
            </>
          ))}
        </div>

        <div style={overviewItem}>
          <span style={itemLabel}>Address</span>
          <span style={itemValue}>{props.policyDetails[0].address}</span>
        </div>
      </div>
    );
  }
}
